// Framework
import { Component, OnInit } from "@angular/core";
// Services
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-privacy-policy",
    templateUrl: "./privacy-policy.component.html",
    styleUrls: ["./privacy-policy.component.scss"]
})
export class PrivacyPolicyComponent implements OnInit {

    get currentLang(): string {
        return this.translate.currentLang;
    }

    constructor(private translate: TranslateService) { }

    ngOnInit(): void {
    }
}
